class Profile {
    constructor(name = null, nickname = null, birthday = null, email = null, mdn = null, contractStatus = null, productType = null, pid = null, visit = null) {
        this.name = name;
        this.nickname = nickname;
        this.birthday = birthday;
        this.email = email;
        this.mdn = mdn;
        this.contractStatus = contractStatus;
        this.productType = productType;
        this.pid = pid;
        this.visit = visit;
    }
    buildFromObject(object) {
        if (object) {
            if (object.name) {
                this.name = object.name;
            }
            if (object.nickname) {
                this.nickname = object.nickname;
            }
            if (object.birthday) {
                this.birthday = object.birthday;
            }
            if (object.email) {
                this.email = object.email;
            }
            if (object.mdn) {
                this.mdn = object.mdn;
            }
            if (object.contractStatus) {
                this.contractStatus = object.contractStatus;
            }
            if (object.productType) {
                this.productType = object.productType;
            }
            if (object.pid) {
                this.pid = object.pid
            }
            if (object.visit){
                this.visit = object.visit;
            }
        }
    }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/model/common/profile.js